import classNames from "classnames";
import * as React from "react";
import { forwardRef, RefObject } from "react";
import { CssProps, extractCssProps } from "./cssProps";
import * as styles from "./Text.less";

export type TextProps = {
    /**
     * Small text size and line-height.
     */
    small?: boolean;
    /**
     * Restrict the text to a single line and truncate with ellipsis if it is too long to all fit.
     */
    truncate?: boolean;
    /**
     * Font weight.
     */
    weight?: "normal" | "semibold";
    /**
     * The DOM tag to use for the element.
     * @example "div", "h2", "p"
     * @default "span"
     */
    tag?: keyof JSX.IntrinsicElements;
} & CssProps &
    React.HTMLAttributes<HTMLElement>;

// use ref and HTMLAttributes to work as a trigger in QTooltip component
export const Text = forwardRef(
    ({ small, weight, truncate, className, tag = "span", ...restProps }: TextProps, ref: RefObject<HTMLElement>) => {
        const Component = tag as any;
        const { cssClass, style, props } = extractCssProps(restProps);

        return (
            <Component
                className={classNames(
                    small && styles.small,
                    weight && styles[weight],
                    truncate && styles.truncate,
                    cssClass,
                    className
                )}
                style={style}
                ref={ref}
                {...props}
            />
        );
    }
);

Text.displayName = "Text";

export { styles as textStyles };
